import React, { useMemo } from "react";
import { IoChatbubbleEllipses } from "react-icons/io5";
import UserPadrao from "../../assets/participantes/user_padrao.jpg";
import UserPadraoM from "../../assets/participantes/Ícone-1-200x200.jpg";
import UserPadraoF from "../../assets/participantes/Ícone-2-200x200.jpg";
import { Link } from "react-router-dom";

const LABEL_TIPO = {
  convidado: "Convidado",
  patrocinador: "Patrocinador",
  participante_patrocinador: "Patrocinador",
  administracao_dash: "Organização",
};

const ItemParticipantes = ({ participante }) => {
  const avatar = useMemo(() => {
    if (participante?.avatar && participante.avatar !== "") {
      return participante.avatar;
    }
    if (participante?.sexo === "masculino") {
      return UserPadraoM;
    }
    if (participante?.sexo === "feminino") {
      return UserPadraoF;
    }
    return UserPadrao;
  }, [participante]);

  const iniciais = useMemo(() => {
    const partes = String(participante?.nome || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!partes.length) return "?";
    if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
    return `${partes[0][0]}${partes[partes.length - 1][0]}`.toUpperCase();
  }, [participante?.nome]);

  const tipoLabel = LABEL_TIPO[participante?.tipo] || null;
  const cargo = participante?.cargo || "Cargo não informado";
  const empresa = participante?.empresa || "Empresa não informada";

  return (
    <article className="pp-card">
      <div className="pp-card-main">
        <div className="pp-avatar-wrap" aria-hidden>
          <img className="pp-avatar" src={avatar} alt="" />
          <span className="pp-avatar-fallback">{iniciais}</span>
        </div>

        <div className="pp-card-info">
          <div className="pp-card-top">
            <h2 className="pp-card-nome">
              {participante?.nome || "Não informado"}
            </h2>
            {tipoLabel ? (
              <span className={`pp-badge pp-badge--${participante?.tipo || "outro"}`}>
                {tipoLabel}
              </span>
            ) : null}
          </div>
          <p className="pp-card-cargo">{cargo}</p>
          <p className="pp-card-empresa">{empresa}</p>
        </div>
      </div>

      <Link
        to={`/private/chat/${participante.id}`}
        className="pp-btn-msg"
        aria-label={`Enviar mensagem para ${participante?.nome || "participante"}`}
      >
        <IoChatbubbleEllipses aria-hidden />
        <span className="pp-btn-msg-label">Mensagem</span>
      </Link>
    </article>
  );
};

export default ItemParticipantes;
